var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 1)?_c('TeacherDailyAttendanceTableControl'):(_vm.type === 2)?_c('TeacherMonthlyAttendanceTableControl'):(_vm.type === 3)?_c('TeacherYearlyAttendanceTableControl'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }